export const ADD_CONTRACT_MODAL_NAME = 'ADD_CONTRACT_MODAL_NAME';
